import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { Bounce, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from '../config';
import { useTranslation } from 'react-i18next';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ mode: "onBlur" });

  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleFormSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await fetch(`${config.apiUrl}/clients/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: data.email }),
      });

      const result = await response.json();

      if (response.ok) {
        setEmailSent(true);
        toast.success(result.message || t("Check your email"), {
          position: "top-center",
          autoClose: 5000,
          transition: Bounce,
        });
        reset();
      } else {
        toast.error(result.error || t("Request failed"), {
          position: "top-center",
          autoClose: 5000,
          transition: Bounce,
        });
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.", {
        position: "top-center",
        autoClose: 5000,
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#fdf6ec] flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md bg-white shadow-lg rounded-3xl px-6 py-8">
        <h2 className="text-xl font-bold text-center text-[#0a2942] mb-4">
          {t("forgotpassword")}
        </h2>

        {!emailSent ? (
          <form onSubmit={handleSubmit(handleFormSubmit)} className="space-y-4">
            <input
              type="email"
              {...register("email", { required: t("email required") })}
              placeholder={t("Enter your email")}
              className={`w-full px-4 py-3 rounded-full bg-[#f0f9ff] focus:ring-2 focus:ring-[#47b5ff]`}
            />
            {errors.email && (
              <p className="text-xs text-red-500">{errors.email.message}</p>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-slate-800 hover:bg-[#ff9933] text-white font-bold py-3 rounded-full transition duration-200"
            >
              {loading ? t("sending...") : t("Send Reset Link")}
            </button>
          </form>
        ) : (
          <div className="text-center space-y-3">
            <p className="text-green-700 font-medium">
              ✅ {t("We’ve sent you an email with a reset link.")}<br />
              {t("Please check your inbox or junk folder.")}
            </p>
            <p className="text-sm text-gray-500">{t("Didn’t receive it? You can try again in a few minutes.")}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
